import { useEffect, useState } from "react";
import { type DMCScanner } from "./DMCScanner";

export const useDMCScanner = () => {
  const [loading, setLoading] = useState(true);
  const [scanner, setScanner] = useState<DMCScanner | null>(null);

  useEffect(() => {
    (async () => {
      const module = await import("./DMCScanner");
      const scanner = module.createDMCScanner(
        window.SCHA.config.oneCodeImplUrl + "/",
        window.SCHA.config.oneCodeImplUrl + "/model.onnx"
      );
      scanner.onReady().then(() => {
        setScanner(scanner);
        setLoading(false);
      });
    })();
  }, []);

  if (loading) {
    return {
      loading: true,
      scanner: null,
    } as const;
  } else {
    return {
      loading: false,
      scanner: scanner!,
    } as const;
  }
};
